import { Action } from '@ngrx/store';
import { TSitePlanWidth } from './ui.model';

export enum ActionTypes {
  SET_SITE_PLAN_WIDTH = '[Component] SetSitePlanWidth',
  SET_SITE_PLAN_WIDTH_FROM_DB = '[Component] SetSitePlanWidthFromDb',
}

export class SetSitePlanWidth implements Action {
  readonly type = ActionTypes.SET_SITE_PLAN_WIDTH;
  constructor(
    readonly payload: {
      workspaceId: string;
      width: string;
    },
  ) {}
}

export class SetSitePlanPreferencesFromDB implements Action {
  readonly type = ActionTypes.SET_SITE_PLAN_WIDTH_FROM_DB;
  constructor(
    readonly payload: {
      sitePlanWidth: TSitePlanWidth;
    },
  ) {}
}

export type ActionsUnion = SetSitePlanWidth | SetSitePlanPreferencesFromDB;
